import './utils/polyfill';
import ReactDOM from 'react-dom/client';
import App from './app';

const root = ReactDOM.createRoot(document.getElementById('app') as HTMLElement);
root.render(<App />);
